import * as React from "react";
import ReactDOM from 'react-dom';

import { ComboBox } from 'office-ui-fabric-react/lib/ComboBox';
import { ChoiceGroup} from 'office-ui-fabric-react/lib/ChoiceGroup';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { DetailsList,  DetailsListLayoutMode,  SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { DatePicker  } from 'office-ui-fabric-react/lib/DatePicker';
import { Label } from 'office-ui-fabric-react/lib/Label';
import {CSVLink} from 'react-csv';

/* https://www.npmjs.com/package/react-google-charts */
import { GoogleChart } from "./classi/GoogleChart.js";

import { Config } from './Config.js';
import { Azioni } from './classi/Azioni.js';
import { Session } from './classi/Session.js';
import { Utils } from './classi/Utils.js';

import './css/Site.css';
import './css/Fatture.css';
import './css/Registri.css';

const sessione = new Session();
const azioni = new Azioni();
const config = new Config();
const utils = new Utils();

const DayPickerStrings = config.getDayPickerStrings();
const firstDayOfWeek = config.getPrimoGiornoSettimana();

export class Registri extends React.Component  {
    
    constructor()
    {
        super();
        
        this.state = {
            
            titolo : 'Registri',
            
            filterDataRegDa: new Date(),
            filterDataRegA: new Date(),
            visualizza:'nascosto',
            visualizzagas:'nascosto',
            visualizzadettagliogas:'nascosto',
            
            divwarning:'nascosto',
            
            POD:'',
            TIPO:'', // E - G
            ID_SITO:'',
            PODselezionato:'',
            
            erroreCombo : 'Sito non selezionato',
            errorMessage:'',
            registri:[],
            registriorig:[],
            
            tipoGrafico : 'kWh',
            
            f1:true,
            f2:true,
            f3:true,
            f7:false,
            f114:false,
            f115:false,
            
            xslee:'nascosto',
            xslgas:'nascosto',
            xslsingle:'',
            
            registriEE:[],
            registriGAS:[],
            loadingdati : 'nascosto'
            
        }
        
        this._siti = [];
        this._items = [];
        this._itemsdetail = [];
        
        this._caricaGrafico = this._caricaGrafico.bind(this);
        this.popolaElencoSiti = this.popolaElencoSiti.bind(this);
        this._onSelectDateRegDa = this._onSelectDateRegDa.bind(this);
        this._onSelectDateRegA = this._onSelectDateRegA.bind(this);
        this._calcolaRegistri = this._calcolaRegistri.bind(this);
        this._onChangeCombo = this._onChangeCombo.bind(this);
        this._onChangeOption = this._onChangeOption.bind(this);
        
        this._onCheckboxChange = this._onCheckboxChange.bind(this);
        this._onCheckboxChangeF1 = this._onCheckboxChangeF1.bind(this);
        this._onCheckboxChangeF2 = this._onCheckboxChangeF2.bind(this);
        this._onCheckboxChangeF3 = this._onCheckboxChangeF3.bind(this);
        this._onCheckboxChangeMono = this._onCheckboxChangeMono.bind(this);
        this._onCheckboxChangePicco = this._onCheckboxChangePicco.bind(this);
        this._onCheckboxChangeFuori = this._onCheckboxChangeFuori.bind(this);
        this._caricaDettaglioGas = this._caricaDettaglioGas.bind(this);
        
        this._onChangeChoiceSiti = this._onChangeChoiceSiti.bind(this);
        
        this.popolaElencoSiti();
    }
    
    
    componentDidMount() {
        
        let today = new Date();
        let lastdaypreviosemonth = new Date( today.getFullYear() , today.getMonth(), 0 , 0, 0, 0, 0);
        let firstdaypreviosemonth = new Date( today.getFullYear() , today.getMonth()-1, 1 , 0, 0, 0, 0);
        
        if( sessione.get('filterdataregda') !== '' && sessione.get('filterdataregda')!=='undefined' && sessione.get('filterdataregda')!==null ){
            firstdaypreviosemonth = new Date(sessione.get('filterdataregda'));
        }
        
        if( sessione.get('filterdatarega') !== '' && sessione.get('filterdatarega')!=='undefined' && sessione.get('filterdatarega')!==null ){
           lastdaypreviosemonth = new Date(sessione.get('filterdatarega'));
        }
        
        this.setState({id_cliente: sessione.get('id_cliente') , filterDataRegDa : firstdaypreviosemonth , filterDataRegA : lastdaypreviosemonth });
        
        utils.setBoxInfoCliente();

        let alternativa = utils.getObjUser('MENU_ALT_REGISTRI' , 'menu' , '');
        if( alternativa !== null && alternativa.trim() !=='' ){ this.setState({ titolo : alternativa }); }
    }
    
    _caricaDettaglioGas()
    {
        this.setState({visualizzadettagliogas:'' });
    }
    
    _onChangeOption( event ,option )
    {
        this.setState({tipoGrafico:option.key });
    }
    
    _onChangeChoiceSiti( event ,option )
    {
        switch(option.key) {
            case 'single':
                this.setState({loadingdati:'nascosto',xslsingle:'', xslee:'nascosto', xslgas:'nascosto' });                
                break;
            case 'tuttiee':
                
                this.setState({loadingdati:'warning centrato margin5', visualizza:'nascosto', visualizzagas:'nascosto', xslsingle:'nascosto', xslee:'nascosto', xslgas:'nascosto' ,divwarning:'nascosto'});
                
                let requestE = new Request( config.get("anagrafica_registriall"),{
                    method: 'POST', mode: 'cors', credentials: "include", 
                    body: JSON.stringify({
                        data_da: utils._onFormatDate( this.state.filterDataRegDa ), 
                        data_a: utils._onFormatDate( this.state.filterDataRegA ),
                        tipo: 'E' ,
                        id_cliente: sessione.get('id_cliente') 
                    })
                });


                fetch(requestE)
                .then(function(response){
                    return response.json();
                }).then(function(result){

                    utils.gestisciMessaggio( result );

                    if (result.success) {

                        this._items = [];

                        // Elenco delle Registri
                        if( result.data!==null )
                        {
                            for(let pod in result.data )
                            {
                                
                                for(let periodo in result.data[pod] )
                                {

                                    let dati = result.data[pod][periodo];

                                    for( let um in dati)
                                    {
                                        // filtrare solo per kWh
                                        if(um === 'kWh'){
                                            let riga = {
                                                'pod':pod, 
                                                'periodo':periodo, 
                                                'um':um , 
                                                'f1':dati[um]['1'] , 
                                                'f2':dati[um]['2'] , 
                                                'f3':dati[um]['3'] , 
                                                'mono':dati[um]['7'], 
                                                'picco':dati[um]['114'], 
                                                'fuori':dati[um]['115'] , 
                                                'PO max prelevata':dati[um]['PO max prelevata'],
                                                'PO impegnata':dati[um]['PO impegnata'],
                                                'PO disponibile':dati[um]['PO disponibile'],
                                                'PO Fatturata':dati[um]['PO Fatturata'],
                                                'tipo contatore':dati['TIPO_CONTATORE'],
                                                'indirizzo':dati['INDIRIZZO'],
                                            };
                                            this._items.push(riga);
                                        }
                                    }
                                }
                            }
                        }
                        
                        // aggiorna state
                        this.setState({registriEE: this._items, loadingdati:'nascosto', xslsingle:'nascosto', xslee:'', xslgas:'nascosto' ,divwarning:'nascosto' });

                    } else {
                        this.setState({loadingdati:'nascosto', xslsingle:'nascosto', xslee:'nascosto', xslgas:'nascosto' ,divwarning:'nascosto'});

                    }
                }.bind(this) );
                
                break;
                
            case 'tuttigas':
                                
                this.setState({loadingdati:'warning centrato margin5', visualizza:'nascosto', visualizzagas:'nascosto', xslsingle:'nascosto', xslee:'nascosto', xslgas:'nascosto' ,divwarning:'nascosto'});
                
                let requestG = new Request( config.get("anagrafica_registriall"),{
                    method: 'POST', mode: 'cors', credentials: "include", 
                    body: JSON.stringify({
                        data_da: utils._onFormatDate( this.state.filterDataRegDa ), 
                        data_a: utils._onFormatDate( this.state.filterDataRegA ),
                        tipo: 'G' ,
                        id_cliente: sessione.get('id_cliente') 
                    })
                });


                fetch(requestG)
                .then(function(response){
                    return response.json();
                }).then(function(result){

                    utils.gestisciMessaggio( result );

                    if (result.success) {

                        this._items = [];

                        // Elenco delle Registri
                        if( result.data!==null )
                        {

                            for(let mensile in result.data )
                            {

                                for( let pdr in result.data[mensile])
                                {
                                    let dati = result.data[mensile][pdr];
                                    
                                    for( let d in dati)
                                    {       
                                        let riga = {
                                            'PDR': dati[d].POD, 
                                            'MESE': dati[d].MESE, 
                                            'CONSUMO': dati[d].VAL_ENERGIA_CORRETTO,
                                            'TIPO_STRUMENTO': dati[d].ID_TIPO_STRUMENTO,
                                            'INDIRIZZO': dati[d].INDIRIZZO,
                                        };   
                                        this._items.push(riga);
                                    }
                                }
                            }
                        }
                        
                        // aggiorna state
                        this.setState({registriGAS: this._items, loadingdati:'nascosto', xslsingle:'nascosto', xslee:'nascosto', xslgas:'' ,divwarning:'nascosto' });

                    } else {
                        this.setState({loadingdati:'nascosto', xslsingle:'nascosto', xslee:'nascosto', xslgas:'nascosto' ,divwarning:''});

                    }
                }.bind(this) );
                
                break;
            default:
                ;
        }
    }
    
    _onCheckboxChange( tipo, isChecked){

        switch(tipo) {
            case 'f1':
                this.setState({f1 :isChecked });
                break;
            case 'f2':
                this.setState({f2 :isChecked });
                break;
            case 'f3':
                this.setState({f3 :isChecked });
                break;
            case 'mono':
                this.setState({f7 :isChecked });
                break;
            case 'picco':
                this.setState({f114 :isChecked });
                break;
            case 'fuori':
                this.setState({f115 :isChecked });
                break;
            default:
                ;
        }

    }
    
    _onCheckboxChangeF1(ev, isChecked){ this._onCheckboxChange( 'f1' , isChecked ); }
    _onCheckboxChangeF2(ev, isChecked){ this._onCheckboxChange( 'f2' , isChecked ); }
    _onCheckboxChangeF3(ev, isChecked){ this._onCheckboxChange( 'f3' , isChecked ); }
    _onCheckboxChangeMono(ev, isChecked){ this._onCheckboxChange( 'mono' , isChecked ); }
    _onCheckboxChangePicco(ev, isChecked){ this._onCheckboxChange( 'picco' , isChecked ); }
    _onCheckboxChangeFuori(ev, isChecked){ this._onCheckboxChange( 'fuori' , isChecked ); }
    
    
    
    _onChangeCombo( option , index, value )
    {
        let errore = '';
        if( option.key==='' ) {errore = 'Sito non selezionato';}
        this.setState({POD:option.key , TIPO:option.tipo , ID_SITO:option.id_sito, erroreCombo:errore , visualizzagas:'nascosto' , visualizza:'nascosto' , visualizzadettagliogas:'nascosto' ,divwarning:'nascosto' });
        
        // svuota grafico
        ReactDOM.unmountComponentAtNode(document.getElementById('graficocolonne'));
    }
    
    _calcolaRegistri()
    {
        if( this.state.POD === '')
        {
            this.setState({ erroreCombo:'Sito non selezionato'});
            return;
        }


        // svuota grafico
        ReactDOM.unmountComponentAtNode(document.getElementById('graficocolonne'));
        

        let request = new Request( config.get("anagrafica_registri"),{
            method: 'POST', mode: 'cors', credentials: "include", 
            body: JSON.stringify({
                data_da: utils._onFormatDate( this.state.filterDataRegDa ), 
                data_a: utils._onFormatDate( this.state.filterDataRegA ),
                pod: this.state.POD ,
                tipo: this.state.TIPO ,
                id_sito :  this.state.ID_SITO,
                id_cliente: sessione.get('id_cliente') 
            })
        });


        fetch(request)
        .then(function(response){
            return response.json();
        }).then(function(result){
            
            utils.gestisciMessaggio( result );
            
            if (result.success) {

                this._items = [];


                if( this.state.TIPO === 'E' ) // casistica energia elettrica
                {
                    // Elenco delle Registri
                    if( result.data!==null )
                    {
                        var oldperiodo = '';

                        for(let periodo in result.data )
                        {
                            let dati = result.data[periodo];

                            for( let um in dati)
                            {
                                var scriviperiodo = '';
                                if(oldperiodo==='' || oldperiodo !== periodo){scriviperiodo = periodo;}

                                let riga = {'periodo':scriviperiodo, 'um':um , 'f1':dati[um]['1'] , 'f2':dati[um]['2'] , 'f3':dati[um]['3'] , 'mono':dati[um]['7'], 'picco':dati[um]['114'], 'fuori':dati[um]['115'] };   
                                this._items.push(riga);

                                oldperiodo = periodo;
                            }
                        }

                        let classvisualizza = '';
                        let classwarning = 'nascosto';
                        if( utils.isObjectFull( result.data ) === false){classwarning = 'warning centrato margin5'; classvisualizza='nascosto';}

                        // this.setState({visualizza:''});
                        setTimeout(function(){this.setState({registriorig : result.data , registri: this._items, visualizza:classvisualizza, visualizzagas:'nascosto', visualizzadettagliogas:'nascosto' ,divwarning:classwarning }); 
                                document.getElementById('elencoregistri').scrollIntoView();
                        }.bind(this) ,500);
                        
                    }
                    else
                    {
                        this.setState({visualizza:'nascosto', visualizzagas:'nascosto', visualizzadettagliogas:'nascosto' ,divwarning:'warning centrato margin5' });
                    }
                }
                
                if( this.state.TIPO === 'G' ) // casistica GAS
                {
                    if( result.data!==null )
                    {
                        let visualizzagas = 'nascosto';
                        let classwarning = 'nascosto';
                        
                        if('mensile' in result.data){ this._items = result.data.mensile; visualizzagas = ''; } else {this._items = []; classwarning = 'warning centrato margin5'; }
                        if('giornaliero' in result.data){ this._itemsdetail = result.data.giornaliero; } else {this._itemsdetail = []; }
                        
                        setTimeout(function(){this.setState({registriorig : result.data , registri: this._items , visualizzagas:visualizzagas , visualizza:'nascosto', visualizzadettagliogas:'nascosto' ,divwarning:classwarning });
                            utils.vaiAId( 'elencoregistri' );
                        }.bind(this) ,500);
                    } else {
                        this.setState({visualizza:'nascosto', visualizzagas:'nascosto', visualizzadettagliogas:'nascosto' ,divwarning:'warning centrato margin5' });
                    }
                }
                
            } else {
                this.setState({visualizza:'nascosto', visualizzagas:'nascosto', visualizzadettagliogas:'nascosto' ,divwarning:'warning centrato margin5'});
                
            }
        }.bind(this) )
    }
    
    _caricaGrafico()
    {
        // calcola i dati
        let _dati = [];
        let _testa = [];
        let _reg = this.state.registriorig;
     
        if( this.state.TIPO === 'E' )
        {
            _testa.push('Periodo');
            if( this.state.f1 === true){ _testa.push('F1');}
            if( this.state.f2 === true){ _testa.push('F2');}
            if( this.state.f3 === true){ _testa.push('F3');}
            if( this.state.f7 === true){ _testa.push('Monoraria');}
            if( this.state.f114 === true){ _testa.push('Picco');}
            if( this.state.f115 === true){ _testa.push('FuoriPicco');}

            _dati.push(_testa);

            for(let periodo in _reg )
            {
                let dati = _reg[periodo];

                for( let um in dati)
                {
                    if(um === this.state.tipoGrafico)
                    {
                        let _riga = [];

                        _riga.push(utils.periodoShort(periodo));

                        if( this.state.f1 === true){ _riga.push(dati[um]['1']);}
                        if( this.state.f2 === true){ _riga.push(dati[um]['2']);}
                        if( this.state.f3 === true){ _riga.push(dati[um]['3']);}
                        if( this.state.f7 === true){ _riga.push(dati[um]['7']);}
                        if( this.state.f114 === true){ _riga.push(dati[um]['114']);}
                        if( this.state.f115 === true){ _riga.push(dati[um]['115']);}

                        _dati.push(_riga);
                    }

                }
            }
        }
       
        
        if( this.state.TIPO === 'G' )
        {
            _testa.push('Periodo');
            _testa.push('Consumo Non Correto');
            _testa.push('Consumo Correto');

            _dati.push(_testa);

            for(let i in _reg.mensile )
            {
                let dati = _reg.mensile[i];
                let _riga = [];
                
                let energia = parseFloat(dati['VAL_ENERGIA']);
                let energiacorretto = parseFloat(dati['VAL_ENERGIA_CORRETTO']);
                
                _riga.push(dati['MESE']);
                _riga.push(energia);
                _riga.push(energiacorretto);
                
                _dati.push(_riga);
            }
        }
        
        // console.log(_dati);
        ReactDOM.unmountComponentAtNode(document.getElementById('graficocolonne'));
        ReactDOM.render(<GoogleChart dati={_dati} />, document.getElementById('graficocolonne'));
        
        utils.vaiAId( 'graficocolonne' );
    }
    
    popolaElencoSiti()
    {
        var siti = sessione.get('siti');
        
        var opzioni = []
        opzioni.push({ key:'' , text:'' })
        
        if( siti !== null ){
            for( let i =0; i < siti.length ; i++ )
            {
                let testo = siti[i].POD+ ' '+( siti[i].TIPO === 'E' ? ' (EE) ' : ' (GAS) ')+' '+siti[i].INDIRIZZO_SITO+ ' '+siti[i].NOME_COMUNE;
                opzioni.push({ key:siti[i].POD , text:testo , tipo:siti[i].TIPO , id_sito: siti[i].SITO})

                if( siti.length === 1)
                {
                    // se esiste un solo pod lo seleziono di default
                    setTimeout(function(){
                        this.setState({POD: siti[i].POD, ID_SITO: siti[i].SITO, PODselezionato:siti[i].POD , TIPO:siti[i].TIPO , erroreCombo:'' });
                    }.bind(this),50);
                }
            }
        }
        
        this._siti = opzioni;
    }
    
    _onSelectDateRegDa ( date: Date | null | undefined) {
        this.setState({ filterDataRegDa: date });
        sessione.set('filterdataregda', date );
        
        // sul cambio della data da cambio la data a + 1 anno
        let dt = new Date( date.getFullYear() , date.getMonth()+12, 0 , 0, 0, 0, 0);
        this._onSelectDateRegA(dt);
        
        this.setState({loadingdati:'nascosto',xslee:'nascosto', xslgas:'nascosto' });
    };
    
    _onSelectDateRegA ( date: Date | null | undefined) {
        this.setState({ filterDataRegA: date });
        sessione.set('filterdatarega', date );
        
        this.setState({loadingdati:'nascosto',xslee:'nascosto', xslgas:'nascosto' });
    };
    
    
    render() {

        return (

            <div id="inner-container">
                <Label className='ms-fontSize-xxl titolo-pagina'>{this.state.titolo}<span id='boxdettagliocliente'></span></Label>

                <div id='filtri'>

                    <div className='boxsearch'>
                        <label className='ms-bgColor-themePrimary ms-font-m-plus'><span>Periodo</span></label>
                        
                        <div id='ricercada'>

                            <DatePicker id='filtradatada'
                                label='Da Data'
                                firstDayOfWeek={firstDayOfWeek}
                                strings={DayPickerStrings}
                                placeholder="Seleziona una data"
                                dateFormat="DD-MM-YYYY"
                                formatDate={utils._onFormatDate}
                                locale='it'
                                value={this.state.filterDataRegDa}
                                onSelectDate={this._onSelectDateRegDa}
                                className='ms-font-m-plus'
                             />

                        </div>

                        <div id='ricercaa'>

                            <DatePicker id='filtradataa'
                                label='A Data'
                                firstDayOfWeek={firstDayOfWeek}
                                strings={DayPickerStrings}
                                placeholder="Seleziona una data"
                                dateFormat="DD-MM-YYYY"
                                formatDate={utils._onFormatDate}
                                locale='it'
                                value={this.state.filterDataRegA}
                                onSelectDate={this._onSelectDateRegA}
                                className='ms-font-m-plus'
                             />

                        </div>
                    </div>
                    
                    <div className='boxsearch'>
                        <label className='ms-bgColor-themePrimary ms-font-m-plus'><span>Selezionare Sito</span></label>
                        <ComboBox
                            allowFreeform={true}
                            defaultSelectedKey=""
                            selectedKey={this.state.PODselezionato}
                            autoComplete="on"
                            options={this._siti}
                            onChanged={this._onChangeCombo}
                            errorMessage={this.state.erroreCombo}
                        />
                        
                        <div className='selezioneQualiSiti'>
                            <ChoiceGroup
                                options={[ {key:'single', text:'Singolo Sito'},{key:'tuttiee', text:'Tutt Siti EE'},{key:'tuttigas', text:'Tutti Siti GAS'} ]}
                                onChange={this._onChangeChoiceSiti}
                                required={false}
                                defaultSelectedKey="single"
                            />
                        </div>
                    </div>
                    
                
                    <div className='centrato calcolaregistri'>
                        <DefaultButton
                            primary={true}
                            text="Calcola"
                            onClick={this._calcolaRegistri}
                            allowDisabledFocus={true}
                            className={this.state.xslsingle}
                          />
                    </div>
                    
                    <div id="scaricotutti" >
                        <CSVLink data={this.state.registriEE} separator={";"} filename={"elenco_registri_ee.csv"} className={this.state.xslee + ' btn btn-primary'} target="_blank" ><div className="ms-BrandIcon--icon48 ms-BrandIcon--excel"></div><span>Scarica CSV EE</span></CSVLink>
                        <CSVLink data={this.state.registriGAS} separator={";"} filename={"elenco_registri_gas.csv"} className={this.state.xslgas + ' btn btn-primary'} target="_blank" ><div className="ms-BrandIcon--icon48 ms-BrandIcon--excel"></div><span>Scarica CSV GAS</span></CSVLink>
                    </div>
        
                </div>
                
                
                
                <div>
                    <div id='graficocolonne'></div>
                    
                    <div id='warningdati' className={this.state.divwarning} >Dati Non Presenti</div>
                    
                    <div id='loadingdati' className={this.state.loadingdati} >Caricamento Dati ...</div>
                      
                    <div id="elencoregistri" className={this.state.visualizza} >
                    
                        <div id="scarico" >
                        <CSVLink data={this.state.registri} separator={";"} filename={"elenco_registri.csv"} className="btn btn-primary" target="_blank" ><div className="ms-BrandIcon--icon96 ms-BrandIcon--excel"></div><span>Scarica CSV</span></CSVLink>
                        </div>

                        <Label className='ms-fontSize-m sottolineato'><b>Seleziona un tipo di grafico e una o piu' fasce</b></Label>

                        <div className='selezioneContent'>
                            <ChoiceGroup
                                options={[ {key:'kWh', text:'kWh'},{key:'kvarh', text:'kvarh'},{key:'kW max', text:'kW max'} ]}
                                onChange={this._onChangeOption}
                                required={false}
                                defaultSelectedKey="kWh"
                              />
                        </div>

                        <div className='selezioneContent'>
                            <Checkbox label="F1" boxSide="start" checked={this.state.f1} onChange={this._onCheckboxChangeF1} name='F1' />
                            <Checkbox label="F2" boxSide="start" checked={this.state.f2} onChange={this._onCheckboxChangeF2} name='F2' />
                            <Checkbox label="F3" boxSide="start" checked={this.state.f3} onChange={this._onCheckboxChangeF3} name='F3' />
                            
                            <Checkbox label="Monoraria" boxSide="start" checked={this.state.f7} onChange={this._onCheckboxChangeMono} name='F7' />
                            <Checkbox label="Picco" boxSide="start" checked={this.state.f114} onChange={this._onCheckboxChangePicco} name='F114' />
                            <Checkbox label="Fuoripicco" boxSide="start" checked={this.state.f115} onChange={this._onCheckboxChangeFuori} name='F115' />
                        </div>

                        <div className='selezioneContent'>
                        <DefaultButton
                            primary={true}
                            data-automation-id="test"
                            text="Carica Grafico"
                            onClick={this._caricaGrafico}
                            allowDisabledFocus={true}
                            iconProps={{ iconName: 'BarChart4' }}
                        />
                        </div>
                    
                    </div>  
                    
                    <div id="elencoregistridetail" className="DetailListContainer">
                    
                        <DetailsList
                            className={this.state.visualizza}
                            items={this.state.registri}
                            columns={ azioni.restituisciColonneRegistri() }
                            setKey="set"
                            layoutMode={DetailsListLayoutMode.fixedColumns}
                            selectionMode={SelectionMode.none}
                            selectionPreservedOnEmptyClick={true}
                            onItemInvoked={this._onItemInvoked}
                        />
                    </div>
                    
                    
                    {/* SEZIONE GAS */}
                    
                    <div id="elencoregistrigas" className={this.state.visualizzagas} >
                        
                        
                        <div id="scarico" >
                        <CSVLink data={this.state.registri} separator={";"} filename={"elenco_registri.csv"} className="btn btn-primary" target="_blank" ><div className="ms-BrandIcon--icon96 ms-BrandIcon--excel"></div><span>Scarica CSV</span></CSVLink>
                        </div>
                        
                        <div className='selezioneContent'>
                        <DefaultButton
                            primary={true}
                            data-automation-id="test"
                            text="Carica Grafico"
                            onClick={this._caricaGrafico}
                            allowDisabledFocus={true}
                            iconProps={{ iconName: 'BarChart4' }}
                        />
                        </div>
                    </div>
                    
                    <div id="elencoregistrigasdetail" className="DetailListContainer">
                    
                        <DetailsList
                            className={this.state.visualizzagas}
                            items={this.state.registri}
                            columns={ azioni.restituisciColonneRegistriGas() }
                            setKey="set"
                            layoutMode={DetailsListLayoutMode.fixedColumns}
                            selectionMode={SelectionMode.none}
                            selectionPreservedOnEmptyClick={true}
                            onItemInvoked={this._onItemInvoked}
                        />
                        
                        <div className="centrato margin5">
                        <DefaultButton
                            className={this.state.visualizzagas}
                            primary={true}
                            text="Visualizza Dettaglio Giornaliero"
                            onClick={this._caricaDettaglioGas}
                            allowDisabledFocus={true}
                            iconProps={{ iconName: 'BulletedList2' }}
                        />
                        </div>
                        
                        
                        <DetailsList
                            className={this.state.visualizzadettagliogas}
                            items={this._itemsdetail}
                            columns={ azioni.restituisciColonneDettaglioGas() }
                            setKey="set"
                            layoutMode={DetailsListLayoutMode.fixedColumns}
                            selectionMode={SelectionMode.none}
                            selectionPreservedOnEmptyClick={true}
                            onItemInvoked={this._onItemInvoked}
                        />
                        
                        
                    </div>
                      
                </div>
                
            </div>


        );      
    }  

};
export default Registri;


// WEBPACK FOOTER //
// ./src/AcComponents/Registri.js